import { AnalyticsFeatures } from 'modules/application/detail/analytics/AnalyticsFeatures';
const DEFAULT_DATA_SOURCE = 'db';
const LAKE_DATA_SOURCE = 'lake';
const GET_ACTIONS_FOR_CATEGORIES_TAKE_SIZE = 10000;
const PENDING_STATUS_CODE = 7390;
const MAX_RETRY_COUNT = 10;
const MAX_LOAD_COUNT = GET_ACTIONS_FOR_CATEGORIES_TAKE_SIZE * 10;
export class EventTrackAnalyticsService {
    static $inject = ['MessagingHubService', 'DEFAULT_PAGE_SIZE'];
    constructor(MessagingHubService, DEFAULT_PAGE_SIZE) {
        this.MessagingHubService = MessagingHubService;
        this.DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;
    }
    async getCategories(filter = undefined, pagination = { take: this.DEFAULT_PAGE_SIZE }) {
        const originDataSource = await this.getDataSourceName();
        const { take } = pagination;
        const queryUri = filter
            ? `/event-track?categoryFilter=${filter}&dataSource=${originDataSource}&$take=${take}`
            : `/event-track?dataSource=${originDataSource}&$take=${take}`;
        const { items } = await this.getData({
            method: 'get',
            uri: queryUri,
        });
        return items.map((item) => ({
            key: item.category,
            value: item.category,
        }));
    }
    async getActionsForCategory({ category, endDate, startDate, }) {
        const originDataSource = await this.getDataSourceName();
        let canLoadMoreData = true;
        let actionsForCategory = [];
        let skipData = 0;
        while (canLoadMoreData) {
            const { items } = await this.getData({
                method: 'get',
                uri: `/event-track/${encodeURIComponent(category)}?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}&dataSource=${originDataSource}&$take=${GET_ACTIONS_FOR_CATEGORIES_TAKE_SIZE}&$skip=${skipData}`,
            });
            skipData += GET_ACTIONS_FOR_CATEGORIES_TAKE_SIZE;
            canLoadMoreData = items.length == GET_ACTIONS_FOR_CATEGORIES_TAKE_SIZE &&
                MAX_LOAD_COUNT >= skipData;
            actionsForCategory = actionsForCategory.concat(items);
        }
        return actionsForCategory;
    }
    async getEventTrackCategoryCount({ category, endDate, startDate, }) {
        const { count } = await this.getData({
            method: 'get',
            uri: `/event-track-count/${encodeURIComponent(category)}?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
        });
        return count;
    }
    async getData(commandBody, retryCount = 0) {
        try {
            return await this.MessagingHubService.sendCommand(commandBody);
        }
        catch (error) {
            if (error.code === PENDING_STATUS_CODE && retryCount < MAX_RETRY_COUNT) {
                retryCount++;
                return new Promise((resolve) => {
                    setTimeout(async () => resolve(await this.getData(commandBody, retryCount)), 1000);
                });
            }
            console.error(error);
        }
    }
    async getDataSourceName() {
        const enableLakeDatasource = await AnalyticsFeatures.enableLakeDatasource();
        if (enableLakeDatasource) {
            return LAKE_DATA_SOURCE;
        }
        return DEFAULT_DATA_SOURCE;
    }
}
EventTrackAnalyticsService.$inject = ['MessagingHubService', 'DEFAULT_PAGE_SIZE'];
